import React from 'react';
import { Card, Result } from 'antd';
import { LockOutlined } from '@ant-design/icons';

const AccessResourcesDenied = ({ title, subTitle, extra }) => {
  return (
    <div className="gx-container-app gx-h-100">
      <Card className="gx-card gx-h-100">
        <Result
          icon={<LockOutlined style={{ fontSize: '60px' }} />}
          status="info"
          title={title}
          subTitle={subTitle}
          extra={extra}
        />
      </Card>
    </div>
  );
};

export default AccessResourcesDenied;
